import Typography from "@material-ui/core/Typography";
import React from "react";
import { type SetterOrUpdater, useRecoilState, useRecoilValue } from "recoil";
import CustomSelect from "../components/CustomSelect";
import { getMonthOptions } from "../constants";
import { localeState, monthState } from "../store";
import Grid from "@material-ui/core/Grid";
import type { SelectOptions } from "../types";

export default function Month() {
	const [month, setMonth] = useRecoilState(monthState);
	const resolvedLocale = useRecoilValue(localeState);
	const [monthOptions, setMonthOptions] = React.useState(
		getMonthOptions(resolvedLocale.shortMonthOptions),
	);

	return (
		<>
			<Grid container>
				<Grid item lg={12} md={12} sm={12} xs={12}>
					<Typography>{resolvedLocale.inText}</Typography>
					<CustomSelect
						options={monthOptions}
						label={resolvedLocale.monthLabel}
						value={month}
						setValue={
							setMonth as SetterOrUpdater<SelectOptions | SelectOptions[]>
						}
						disableClearable
						sort
						disableEmpty
					/>
				</Grid>
			</Grid>
		</>
	);
}
